import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Input, MessageBarBody } from '@fluentui/react-components';
import { DocumentTable20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

// functions
import * as ComponentFunctions from './PractitionerAssociationExport.Form.Functions';

// guide components
import { GuideDrawer } from '../../../../theme/components/GuideDrawer';
import { GuideField, GuideFieldGrid } from '../../../../theme/components/GuideField';
import { GuideMessageBar } from '../../../../theme/components/GuideMessageBar';

const PractitionerAssociationExportFormComponent = (
  props: ComponentFunctions.Props
) => {
  const [t] = useTranslation();

  const today = new Date().toISOString().split('T')[0];
  const firstOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  )
    .toISOString()
    .split('T')[0];

  const [dateFrom, setDateFrom] = useState<string>(firstOfMonth);
  const [dateTo, setDateTo] = useState<string>(today);
  const [submitted, setSubmitted] = useState<boolean>(false);

  useEffect(() => {
    if (submitted && props.successExportingExcel) {
      setSubmitted(false);
      props.onClose();
    }
  }, [props.successExportingExcel]);

  const handleExport = () => {
    if (!dateFrom || !dateTo) return;
    setSubmitted(true);
    props.ExportPractitionerAssociationsToExcel(dateFrom, dateTo);
  };

  return (
    <GuideDrawer
      open={props.isOpen}
      size="small"
      title={t('practitionerAssociationExport.title')}
      onDismiss={props.onClose}
      testId="practitioner-association-export-drawer"
      secondaryAction={{ label: t('common.cancel'), disabled: props.isExportingExcel }}
      primaryAction={{
        label: props.isExportingExcel
          ? t('practitionerAssociationExport.exporting')
          : t('practitionerAssociationExport.exportButton'),
        onClick: handleExport,
        disabled: !dateFrom || !dateTo,
        loading: props.isExportingExcel,
        icon: <DocumentTable20Regular />,
      }}
    >
      <>
        <GuideFieldGrid>
          <GuideField label={t('practitionerAssociationExport.dateFrom')} required>
            <Input type="date" value={dateFrom} onChange={(_e, data) => setDateFrom(data.value || '')} />
          </GuideField>
          <GuideField label={t('practitionerAssociationExport.dateTo')} required>
            <Input type="date" value={dateTo} onChange={(_e, data) => setDateTo(data.value || '')} />
          </GuideField>
        </GuideFieldGrid>
        {props.failOnExportingExcel && (
          <GuideMessageBar intent="error">
            <MessageBarBody>{t('practitionerAssociationExport.exportError')}</MessageBarBody>
          </GuideMessageBar>
        )}
      </>
    </GuideDrawer>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(PractitionerAssociationExportFormComponent as any);
